import { AdjustmentsVerticalIcon } from '@heroicons/react/24/outline';
import { useTranslation } from 'react-i18next';

import AccountMenuItem from '@/components/app-shell/AccountMenuItem';
import AccountRewards from '@/components/app-shell/AccountRewards';
import ConditionalRenderer from '@/components/ui/custom/ConditionalRenderer';
import { useAppShell } from '@/data/context/AppShellContext';
import { isStudent } from '@/functions/auth';
import { ROUTES } from '@/utils/routes';

type AccountMenuContentProps = {
  onNavigate(): void;
  itemClassName?: string;
};

export default function AccountMenuContent({
  onNavigate,
  itemClassName,
}: AccountMenuContentProps) {
  const { user } = useAppShell();
  const { t } = useTranslation('translation', {
    keyPrefix: 'appShell.account',
  });

  return (
    <div className="flex flex-col gap-4">
      <ConditionalRenderer condition={isStudent(user.userType)}>
        <AccountRewards />
        <hr className="my-2 border-base-content/10" />
      </ConditionalRenderer>
      <AccountMenuItem
        to={ROUTES.ACCOUNT.BASE}
        icon={AdjustmentsVerticalIcon}
        label={t('settings')}
        className={itemClassName}
        onClick={onNavigate}
      />
    </div>
  );
}
